import HubTemplate from '@components/templates/HubTemplate/HubTemplate'
import { initializeApollo } from '@gql/client'
import React from 'react'
import { PAGINA_HUB } from 'utils/queries'
import { useArticoliHubQuery } from 'gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'

function Gravidanza({ pagina }) {
  const { data: articoliHub } = useArticoliHubQuery({
    variables: { categorie_ElementiPagina_Pagina_Id: pagina.pk, first: 3, tipo: '3' },
  })

  return (
    <HubTemplate
      pagina={pagina}
      articoliCorrelati={articoliHub?.articoliHub?.edges?.map(({ node }) => ({
        pk: node.pk,
        articolo: node,
      }))}
    />
  )
}

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA_HUB,
    variables: { chiave: 'gravidanza' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 2,
  }
}, '/c/gravidanza')

export default Gravidanza
